<template>
  <div>
    <template v-if="clusterId == null || cluster == null">
      <div
        v-for="event in allEvents"
        class="col-sm-12 col-md-6 col-lg-4"
      >
        <event :event="event" />
      </div>
    </template>

    <template v-else>
      <div
        class="event-block flex-component-block"
        :class="{ 'colour-cluster': colourCluster }"
      >
        <p style="margin-bottom: 4px;">
          <strong v-if="label != null && label !== ''">{{ label }}</strong>
          <strong v-else>{{ cluster.id }}</strong>
        </p>

        <div v-for="event in clusterEvents">
          <event :event="event" />
        </div>

        <p style="margin-bottom: 0px;">
          <em>
            <small>{{ numberOfClusteredEvents }} {{ trans_choice('core.events', numberOfClusteredEvents) }}
            </small>
          </em>
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import Event from './Event.vue'
import _flattenDepth from 'lodash'

export default {

  name: 'EventCluster',
  components: { Event },

  props: {
    clusterId: {
      default: null,
    },
  },

  computed: {
    clusterEvents () {
      if (this.clusterId == null || this.cluster == 0) {
        return {}
      }

      let eventsOfSeries = this.$store.state.eventSeries.event_serie_events
      let events = Object.values(this.cluster.relationships.events.data).map(event => {
        return eventsOfSeries[event.id].attributes
      })
      return this.setEventData(events)
    },

    cluster () {
      let clusters = this.$store.state.eventSeries.event_clusters
      return Object.keys(clusters).length === 0 ? null : clusters[this.clusterId]
    },

    label () {
      return this.cluster.attributes.label
    },

    numberOfClusteredEvents () {
      return Object.keys(this.clusterEvents).length
    },

    allEvents () {
      let coursesWithEvents = this.$store.state.eventSeries.course_event_ids
      let allEvents = this.$store.state.eventSeries.events
      let events = Object.keys(coursesWithEvents).reduce(function (events, courseId) {
        Object.values(coursesWithEvents[courseId]).forEach(eventId => {
          let event = allEvents[courseId][eventId]
          events.push(event)
        })
        return events
      }, [])

      return this.setEventData(events)
    },

    groups () {
      return this.$store.state.eventSeries.groups
    },

    perWeek () {
      return this.$store.state.eventSeries.serie_rules.per_week
    },

    type () {
      return this.$store.state.eventSeries.serie_rules.type
    },
    colourCluster () {
      let coloured_clusters = this.$store.state.eventSeries.coloured_clusters
      return coloured_clusters.indexOf(this.clusterId) > -1
    },
  },

  methods: {
    setEventData (events) {
      return events.map(event => {
        let groupNames = event.group_ids.map(id => { return this.groups[id]?.name })
        return {
          id: event.id,
          name: event.name,
          displayDate: event.displayDate,
          groups: groupNames.join(', '),
        }
      })
    },
  },
}
</script>

<style>
    .event-block {
        border: 1px solid #222;
        padding: 10px 5px;
        margin: 5px 0px;
        min-width: 180px;
    }

    .flex-component-block {
        flex: 1 0 auto;
        overflow: auto;
        margin-right: 10px;
    }

    .colour-cluster {
        background-color: rgb(252, 169, 159);
    }
</style>
